import {
  K8AddPoliciesPage,
  K8AddPoliciesProps,
} from "~/pages/integrations/kubernetes/K8AddPoliciesPage";

const K8AddPoliciesEntryPage = ({ scope }: K8AddPoliciesProps) => {
  return <K8AddPoliciesPage {...{ scope }} />;
};

export default K8AddPoliciesEntryPage;
